var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("b-card", { staticClass: "earnings-card" }, [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col" },
        [
          _c("b-card-title", { staticClass: "mb-1" }, [
            _vm._v(" " + _vm._s(_vm.title) + " ")
          ]),
          _c("h4", { staticClass: "mb-1 text-right" }, [
            _vm._v(" " + _vm._s(_vm.quantity) + " ")
          ])
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-auto text-center" },
        [
          _c(
            "b-avatar",
            { attrs: { size: "48", variant: _vm.color } },
            [_c("feather-icon", { attrs: { size: "34", icon: _vm.icon } })],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }